export default __webpack_public_path__ + "static/media/mountains.fb57acb6.jpg";